import React from 'react';
import './blog-post.css';

import Chi from './pictures/Chi_Dang.png';
import Cynthia from './pictures/Cynthia_Gao.png';
import Kelsey from './pictures/Kelsey_Sun.png';
import Janelle from './pictures/Janelle_Chan.png';
import Huan from './pictures/Huan_Ngyuen.png';
import Harshitha from './pictures/Harshitha_Rebala.png';
import Betty from './pictures/Betty_Cheng.png';
import Mya from './pictures/Mya_Baker.png';
import Rachel from './pictures/Rachel_Hu.png';
import Shayla from './pictures/Shayla_Huang.png';
import Shreya from './pictures/Shreya_Sathyanarayanan.png';
import Sophia from './pictures/Sophia_Lin.png';
import Czarin from './pictures/Czarin_Cruz.png';
import Hoang from './pictures/Hoang_Nguyen.png';


//import reportWebVitals from './reportWebVitals';

const Percentproject = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Percentage Project Photo Campaign</h2>
                    <p class="site-post-meta">March 28th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>                   
                    We worked with Percentage Project this quarter for a photo campaign! 
                    This year, the campaign theme is Allyship in the Face of Adversity.
                    <br></br>
                    <br></br>  
                    The Percentage Project is a 501(c)(3) nonprofit org that aims to foster 
                    inclusivity and belonging through data-driven advocacy within computer science 
                    departments on college campuses nationwide.
                    <br></br>
                    <br></br>  
                    The statistics are based on responses from 515 students at multiple 
                    universities concentrating in a computer science-related discipline 
                    for the 2023 Computer Science Survey. The full data from the survey, 
                    remaining photos of our advocates, and more information can be found at  <a href='https://www.percentageproject.org/' target='_blank' rel="noreferrer">www.percentageproject.org</a> 
                    <br></br>
                     
                    </p>
                     <img src={Chi} alt=""/>
                     <img src={Cynthia} alt=""/>
                     <img src={Kelsey} alt=""/>
                     <img src={Janelle} alt=""/>
                     <img src={Huan} alt=""/>
                     <img src={Harshitha} alt=""/>
                     <img src={Betty} alt=""/>
                     <img src={Mya} alt=""/>
                     <img src={Rachel} alt=""/>
                     <img src={Shayla} alt=""/>
                     <img src={Shreya} alt=""/>
                     <img src={Sophia} alt=""/>
                     <img src={Czarin} alt=""/>
                     <img src={Hoang} alt=""/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Percentproject;

